import React from "react";
import { useGlobalContext } from "store/contexts/globalContext";
import UserInvitationCard from "components/UserInvitationCard.js";
import { useHistory } from "react-router-dom";

export default ({
  user_invitations,
  setInvitations,
  isLoading,
  setInvitationTotal,
  invitationTotal,
}) => {
  const { createTeam, microsoftConfigureTab, ringCentral } = useGlobalContext();
  const history = useHistory();

  const notificationAccepted = (inviteCode, joinTeam) => {
    setInvitations(
      user_invitations.filter((invitation) => {
        return invitation.invitation_code !== inviteCode;
      })
    );

    if (ringCentral) {
      window.location.reload();
    }

    if (
      microsoftConfigureTab &&
      parseInt(microsoftConfigureTab?.entityId) === joinTeam?.id
    ) {
      history.push(
        `/teams/${parseInt(microsoftConfigureTab?.entityId)}/timeline`
      );
    }

    createTeam(joinTeam);

    setInvitationTotal(invitationTotal - 1);
  };

  const notificationRejected = (inviteCode) => {
    setInvitations(
      user_invitations.filter((invitation) => {
        return invitation.invitation_code !== inviteCode;
      })
    );
    setInvitationTotal(invitationTotal - 1);
  };

  return (
    <div className="invitationsList">
      {user_invitations.map((invite) => (
        <UserInvitationCard
          key={invite.id}
          invite={invite}
          onAccept={notificationAccepted}
          onReject={notificationRejected}
        />
      ))}
      {!user_invitations.length && !isLoading && (
        <div className="noInvitation">There is no invitation</div>
      )}
    </div>
  );
};
